import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { selectAccountMembershipId, selectIsMini } from '@shared/api/reduxToolkit';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { SidebarNavList } from '@shared/ui/sidebarNavList';
import { TOOLTIP_NAME } from '@shared/ui/tooltip';

import { companyNavLib } from '../lib';

export const CompanyNav = () => {
	const accountMembershipId = useSelector(selectAccountMembershipId);
	const isMini = useSelector(selectIsMini);
	const { companyId: routeCompanyId } = useParams();
	const { t: tT } = useTranslation(i18TranslationNS);

	const links = companyNavLib(tT);
	const ariaLabel = tT(Translation.COMPANY_NAV_ARIALABEL);

	const buildPath = ({ to }) =>
		to && accountMembershipId && routeCompanyId
			? `/${accountMembershipId}/${routeCompanyId}/${to}`
			: null;

	return (
		<>
			<SidebarNavList
				items={links}
				ariaLabel={ariaLabel}
				isMini={isMini}
				buildPath={buildPath}
				tooltipName={TOOLTIP_NAME.COMPANYPROFILE}
			/>
		</>
	);
};
